import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import Topbar from "../../../components/Topbar/Topbar";
import {
  arrow_icon,
  delete_icon,
  drag,
  edit_icon,
  Search_icon,
} from "../../../assets/img";
import { get, post } from "../../../Services/ApiHandler";
import { URLS } from "../../../Services/Constant";
import { toast } from "react-toastify";
import Loader from "../../../components/Loader";
import { checkPermission } from "../../redux/api/PermissionManager";

const BookingCancelReason = () => {
  const [list, setList] = useState([]);
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState({
    current_page: 1,
    last_page: 1,
    count: 0,
  });
  const [popup, setPopup] = useState(false);
  const [addPopup, setAddPopup] = useState(false);
  const [type, setType] = useState();
  const [errors, setErrors] = useState(false);
  const [tagLine, setTagLine] = useState("10");
  const [show, setShow] = useState(false);
  const [policy, setPolicy] = useState("");
  const [names, setNames] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [editId, setEditId] = useState(null);

  //save reference for dragItem and dragOverItem
  const dragItem = React.useRef(null);
  const dragOverItem = React.useRef(null);

  // drag sorting
  const handleSort = () => {
    let items = [...list];
    const draggedItemContent = items.splice(dragItem.current, 1)[0];
    items.splice(dragOverItem.current, 0, draggedItemContent);
    dragItem.current = null;
    dragOverItem.current = null;
    setList(items);
    setShow(true);
  };

  const handleDeleteList = async () => {
    if (editId) {
      try {
        setLoading(true);
        let res = await post(`${URLS.MASTERURL}${editId}/delete/`);
        if (res?.status === "success") {
          toast.success(res?.message);
        }
        setPopup(false);
        fetch(page);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    }
  };

  const fetch = async (pageNo = 1) => {
    const url = search
      ? `${URLS.MASTERURL}?type=${33}&search=${search}`
      : `${URLS.MASTERURL}?type=${33}&page=${pageNo}`;

    try {
      const res = await get(url);
      setList(res?.data);
    } catch (err) {
      console.error("err", err);
    }
  };

  useEffect(() => {
    fetch(page);
  }, [search, page]);

  const handleDelete = (index) => {
    setNames((prev) => prev.filter((_, i) => i !== index));
  };

  const handleSubmit = async () => {
    if (names.length !== 0) {
      // 1. Check for names already in the list
      const existingNames = names?.filter((n) =>
        list.some((item) => item.name === n),
      );

      if (type === "add") {
        if (existingNames.length > 0) {
          toast.error(`Already exists: ${existingNames.join(", ")}`);
          return; // stop here, don't call API
        }
      }

      // 2. Check for duplicates inside names itself

      const duplicateNames = names?.filter((n, i) => names.indexOf(n) !== i);
      console.log("duplicateNames", duplicateNames);

      if (duplicateNames.length > 0) {
        toast.error(`Duplicates inside names:  ${duplicateNames.join(", ")}`);
        return;
      }
    }

    if (type === "add") {
      if (names.length === 0) {
        setErrors(true);
      } else {
        if (policy.trim() !== "") {
          toast.error("Please add entered data");
          return;
        }

        setLoading(true);
        setAddPopup(false);
        const formdata = new FormData();
        formdata.append("type", 33);
        formdata.append("name", names);
        formdata.append("status", true);
        try {
          const res = await post(`${URLS.MASTERURL}add/`, formdata);
          if (res.status === "success")
            toast.success(res.message || "Added successfully");
          fetch(page);
        } catch (err) {
          console.error(err);
        } finally {
          setLoading(false);
        }
      }
    }

    if (type === "edit") {
      if (!tagLine) {
        setErrors(true);
        toast.error("Please enter tips");
        return;
      } else {
        setAddPopup(false);
        setLoading(true);
        const formdata = new FormData();
        formdata.append("type", 33);
        formdata.append("name", tagLine);
        try {
          const res = await post(`${URLS.MASTERURL}${editId}/edit/`, formdata);
          if (res.status === "success")
            toast.success(res.message || "Edited successfully");
          setEditId(null);
          fetch(page);
        } catch (err) {
          console.error(err);
        } finally {
          setLoading(false);
        }
      }
    }
  };

  const savePosition = async () => {
    try {
      setLoading(true);
      const payload = list.map((item, index) => ({
        id: item.id,
        position: index + 1,
      }));

      const res = await post(`${URLS.MASTERURL}positions/`, payload);
      if (res?.status === "success") {
        toast.success(res?.message || "Position updated");
        setShow(false);
        fetch(page);
      }
    } catch (err) {
      toast.error("Failed to save positions");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    e.preventDefault();

    if (policy.trim() !== "") {
      setNames([...names, policy.trim()]);
      setPolicy("");
      setErrors("");
    }
  };

  const checkMultiplePermission = (array = []) => {
    let show = false;
    array?.map((item) => {
      if (checkPermission(item)) show = true;
    });
    return show;
  };
  return (
    <div>
      <Topbar header={"Master"} subHead={"Booking Cancel Reason"} />
      <div className="d-flex ac-jb">
        <h2 className="f3 fs-sm-16 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-26">
          Total: {pagination.count || list?.length}
        </h2>
        <div className="d-flex ac-js gap-3">
          <div className="search-input">
            <input
              onChange={(e) => setSearch(e.target.value)}
              type="text"
              placeholder="Search"
              style={{ border: "none", width: "150px" }}
            />
            <img src={Search_icon} className="search" />
          </div>
          {checkPermission("CAN-ADD-BOOKING_CANCEL_REASON") && (
            <button
              onClick={() => {
                setNames([]);
                setAddPopup(true);
                setType("add");
              }}
              className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 white add-btn "
            >
              {" "}
              + Add New
            </button>
          )}
          {show && (
            <button
              onClick={savePosition}
              className="submit-btn f2"
              style={{ minWidth: "120px" }}
            >
              Save
            </button>
          )}
        </div>
      </div>

      {/* Table */}
      <div className="mt-5" style={{ width: "100%", overflow: "auto" }}>
        <table
          className="table-design-new"
          style={{ width: "98%", borderRadius: "10px" }}
        >
          <thead>
            <tr className="border-bottom w-100">
              <th className="f-w600  fs-sm-10 fs-md-14 fs-lg-15 fs-xl-16 fs-xxl-18  py-2 gray3  p-2">
                S.No
              </th>
              <th className="f-w600  fs-sm-10 fs-md-14 fs-lg-15 fs-xl-16 fs-xxl-18  py-2 gray3  p-2">
                Reason
              </th>
              {checkPermission("CAN-STATUS-BOOKING_CANCEL_REASON") ? (
                <th className="f-w600  fs-sm-10 fs-md-14 fs-lg-15 fs-xl-16 fs-xxl-18  py-2 gray3  p-2">
                  Status
                </th>
              ) : (
                <th className="f-w600  fs-sm-10 fs-md-14 fs-lg-15 fs-xl-16 fs-xxl-18  py-2 gray3  p-2"></th>
              )}
              {checkMultiplePermission([
                "CAN-EDIT-BOOKING_CANCEL_REASON",
                "CAN-DELETE-BOOKING_CANCEL_REASON",
              ]) && (
                <th className="f-w600  fs-sm-10 fs-md-14 fs-lg-15 fs-xl-16 fs-xxl-18  py-2 gray3  p-2">
                  Action
                </th>
              )}
            </tr>
          </thead>
          <tbody>
            {list?.map((item, index) => (
              <tr
                key={index}
                className="list-item p-2"
                // draggable
                onDragStart={() => (dragItem.current = index)}
                onDragEnter={() => (dragOverItem.current = index)}
                onDragEnd={handleSort}
                onDragOver={(e) => e.preventDefault()}
              >
                <td className="pointerView f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-15 fs-xxl-16 px-3 py-2 mt-2 red list-data ">
                  {(pagination.current_page - 1) * 10 + index + 1}
                </td>
                <td className="pointerView f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-15 fs-xxl-16 px-3 py-2 mt-2 gray2 list-data ">
                  {item?.name}
                </td>
                {checkPermission("CAN-STATUS-BOOKING_CANCEL_REASON") ? (
                  <td className="pointerView f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-15 fs-xxl-16 px-3 py-2 mt-2 gray2 list-data ">
                    <button
                      onClick={() => {
                        if (
                          checkPermission("CAN-STATUS-BOOKING_CANCEL_REASON")
                        ) {
                          post(`${URLS.MASTERURL}${item.id}/status/`, {
                            status: !item.status,
                            type: 11,
                          });
                          toast.success("Status updated Successfully");
                          setTimeout(() => {
                            fetch(page);
                          }, 1000);
                        }
                      }}
                      className={item.status ? "active-btn" : "deactive-btn"}
                    >
                      {item.status ? "Active" : "De-active"}
                    </button>
                  </td>
                ) : (
                  <td className="pointerView f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-15 fs-xxl-16 px-3 py-2 mt-2 gray2 list-data "></td>
                )}
                <td>
                  <div className="d-flex ac-js gap-2">
                    {checkPermission("CAN-EDIT-BOOKING_CANCEL_REASON") && (
                      <button
                        onClick={() => {
                          setAddPopup(true);
                          setType("edit");
                          setTagLine(item.name);
                          setEditId(item.id);
                        }}
                        className="cust-btn "
                      >
                        <img src={edit_icon} alt="" className="edit-btn" />
                      </button>
                    )}
                    {checkPermission("CAN-DELETE-BOOKING_CANCEL_REASON") && (
                      <button
                        onClick={() => {
                          setPopup(true);
                          setEditId(item.id);
                        }}
                        className="cust-btn "
                      >
                        <img src={delete_icon} alt="" className="edit-btn" />
                      </button>
                    )}
                  </div>
                </td>
                <td className="position-relative">
                  <div className="drag-box">
                    <img src={drag} className="drag-img" alt="" />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Popups remain unchanged ... */}
      {addPopup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <div className="d-flex ac-jb">
              <p className="f4 text-start  fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 ">
                {type === "add" ? "Add" : "Edit"}
              </p>
              <CloseSharpIcon
                onClick={() => {
                  setAddPopup(false);
                  setPolicy("");
                  setErrors("");
                  setNames([]);
                }}
                className="pointer"
              />
            </div>
            <div className="d-flex ac-js mt-3">
              <div className="w-100">
                {type === "add" && (
                  <div>
                    <div className="d-flex ae-jb input-border p-1">
                      <textarea
                        style={{ maxHeight: "80px" }}
                        value={policy}
                        onChange={(e) => {
                          setPolicy(e.target.value);
                        }}
                        placeholder="Write Here...."
                        className="border-0 mb-3 w-80"
                      />
                      <button
                        onClick={handleKeyPress}
                        className="submit-btn p-1"
                        style={{ minWidth: "100px" }}
                      >
                        Add
                      </button>
                    </div>
                    {errors && (
                      <p className="err text-start">
                        Please add at least one tagline.
                      </p>
                    )}
                    {names.length > 0 && (
                      <ul
                        className="input-border overflow-scroll mt-2"
                        style={{ minHeight: "50px", maxHeight: "200px" }}
                      >
                        {names?.map((name, index) => (
                          <li key={index} className="d-flex as-js gap-3 mt-2">
                            <img
                              src={arrow_icon}
                              className="bullet-btn"
                              alt=""
                            />
                            <p className="f2 fs-sm-10 fs-md-14 fs-lg-15 fs-xl-14 fs-xxl-16 w-80 text-start">
                              {name}
                            </p>
                            <img
                              src={delete_icon}
                              className="delete-btn"
                              onClick={() => handleDelete(index)} // ✅ pass index, not name
                              alt="delete"
                            />
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                )}
                {type === "edit" && (
                  <input
                    type="text"
                    value={tagLine}
                    onChange={(e) => {
                      setTagLine(e.target.value);
                    }}
                    placeholder="Booking cancel reason"
                    className="input-box"
                  />
                )}
              </div>
            </div>
            <div className="d-flex ac-je px-2 mt-4">
              <button onClick={handleSubmit} className="submit-btn f2 w-40 p-2">
                Submit
              </button>
            </div>
          </div>
        </div>
      )}
      {popup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <p>Are you sure, want to Delete?</p>
            <div className="d-flex ac-jb px-2 mt-5">
              <button onClick={handleDeleteList} className="add-btn w-40">
                Yes
              </button>
              <button
                onClick={() => setPopup(false)}
                className="back-btn f2 w-40"
              >
                No
              </button>
            </div>
          </div>
        </div>
      )}
      {loading && <Loader />}
    </div>
  );
};

export default BookingCancelReason;
